import React from 'react';
import { GoCheckCircle } from 'react-icons/go';
import { StyledAgentCreated } from './AgentSuccessModal.style';
import { useNavigate } from 'react-router-dom';
import Button from '../Button';

const AgentSuccessModal = ({
  desc = 'Congratulations, your agent is active successfully, you can start using it.',
  noBtn,
}) => {
  const navigate = useNavigate();
  return (
    <StyledAgentCreated>
      <div className="holder">
        <div className="img-box">
          <GoCheckCircle className="icon" />
        </div>
        <p>{desc}</p>
      </div>
      {!noBtn && (
        <Button variant="secondary-outline" onClick={() => navigate('/chat')}>
          Continue to chat
        </Button>
      )}
    </StyledAgentCreated>
  );
};

export default AgentSuccessModal;
